import { render, staticRenderFns } from "./passInterview.vue?vue&type=template&id=35e20600&scoped=true&"
import script from "./passInterview.vue?vue&type=script&lang=js&"
export * from "./passInterview.vue?vue&type=script&lang=js&"
import style0 from "./passInterview.vue?vue&type=style&index=0&id=35e20600&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35e20600",
  null
  
)

export default component.exports